var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtOrganization = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 125,
    viewBox: "0 0 150 125",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.064%",
    x2: "99.965%",
    y2: "50.064%",
    id: "pilo5gd4ka"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "-2429.606%",
    x2: "100%",
    y2: "-2429.606%",
    id: "v2pn3yaazb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-474.525%",
    y1: "50.064%",
    x2: "-471.074%",
    y2: "50.064%",
    id: "88f0jnsa6c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.064%",
    x2: "100%",
    y2: "50.064%",
    id: "gibsgkjzwd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "M0 0h50.441v124.888H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.201 67.642h5.312v6.567h-5.312zM23.868 53.73h5.312v6.415h-5.312zM23.868 67.642h5.312v6.567h-5.312zM8.48 53.73h5.312v6.415H8.48zM8.48 67.642h5.312v6.567H8.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.201 82.118h5.312v6.416h-5.312zM23.868 82.118h5.312v6.416h-5.312zM23.868 96.323h5.312v6.416h-5.312zM8.48 82.118h5.312v6.416H8.48z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#64C0C3",
    d: "M37.088 54.081h47.973v70.803H37.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pilo5gd4ka)",
    d: "M0 0h10.185v2.764H0z",
    transform: "translate(40.755 59.63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v2pn3yaazb)",
    d: "M22.09 0h10.424v2.764H22.09z",
    transform: "translate(40.755 59.63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#88f0jnsa6c)",
    d: "M0 8.007h10.185v2.764H0z",
    transform: "translate(40.755 59.63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gibsgkjzwd)",
    d: "M22.09 8.007h10.424v2.764H22.09z",
    transform: "translate(40.755 59.63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#88f0jnsa6c)",
    d: "M0 15.985h10.185v2.764H0z",
    transform: "translate(40.755 59.63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gibsgkjzwd)",
    d: "M22.09 15.985h10.424v2.764H22.09z",
    transform: "translate(40.755 59.63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#88f0jnsa6c)",
    d: "M0 23.992h10.185v2.764H0z",
    transform: "translate(40.755 59.63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gibsgkjzwd)",
    d: "M22.09 23.992h10.424v2.764H22.09z",
    transform: "translate(40.755 59.63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#88f0jnsa6c)",
    d: "M0 0h10.185v2.764H0z",
    transform: "translate(40.755 91.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gibsgkjzwd)",
    d: "M22.09 0h10.424v2.764H22.09z",
    transform: "translate(40.755 91.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#88f0jnsa6c)",
    d: "M0 8.007h10.185v2.764H0z",
    transform: "translate(40.755 91.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gibsgkjzwd)",
    d: "M22.09 8.007h10.424v2.764H22.09z",
    transform: "translate(40.755 91.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#88f0jnsa6c)",
    d: "M0 15.985h10.185v2.764H0z",
    transform: "translate(40.755 91.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gibsgkjzwd)",
    d: "M22.09 15.985h10.424v2.764H22.09z",
    transform: "translate(40.755 91.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#88f0jnsa6c)",
    d: "M0 23.992h10.185v2.764H0z",
    transform: "translate(40.755 91.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gibsgkjzwd)",
    d: "M22.09 23.992h10.424v2.764H22.09z",
    transform: "translate(40.755 91.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M76.598 7.252h43.539v117.636H76.598z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F6C760"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.11 90.24h32.515v2.529H82.11zM82.11 96.19h32.515v2.528H82.11zM82.11 102.114h32.515v2.528H82.11zM82.11 108.06h32.515v2.528H82.11z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#64C0C3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.11 16.603h10.186v2.528H82.11zM104.2 16.603h10.425v2.528H104.2zM82.11 22.552h10.186v2.528H82.11zM104.2 22.552h10.425v2.528H104.2zM82.11 28.476h10.186v2.528H82.11zM104.2 28.476h10.425v2.528H104.2zM82.11 34.422h10.186v2.528H82.11zM104.2 34.422h10.425v2.528H104.2z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#64C0C3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.11 40.29h10.186v2.528H82.11zM104.2 40.29h10.425v2.528H104.2zM82.11 46.24h10.186v2.527H82.11zM104.2 46.24h10.425v2.527H104.2zM82.11 52.163h10.186v2.528H82.11zM104.2 52.163h10.425v2.528H104.2zM82.11 58.11h10.186v2.527H82.11zM104.2 58.11h10.425v2.527H104.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AFD7C7",
    d: "M110.866 75.622H150V125h-39.134z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F6C760"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.74 82.157h4.021v6.416h-4.022zM140.74 96.07h4.021v6.567h-4.022zM129.134 82.157h4.022v6.416h-4.022zM129.134 96.07h4.022v6.567h-4.022zM117.486 82.157h4.022v6.416h-4.022zM117.486 96.07h4.022v6.567h-4.022z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.74 110.55h4.021v6.415h-4.022zM117.486 110.55h4.022v6.415h-4.022z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.201 9.798h5.312v6.416h-5.312zM39.201 23.715h5.312v6.567h-5.312zM23.868 9.798h5.312v6.416h-5.312zM23.868 23.715h5.312v6.567h-5.312zM8.48 9.798h5.312v6.416H8.48zM8.48 23.715h5.312v6.567H8.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.201 38.19h5.312v6.416h-5.312zM23.868 38.19h5.312v6.416h-5.312zM8.48 38.19h5.312v6.416H8.48z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtOrganization);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-organization.f29392e4f7920743df9a243d86d448f2.svg";